import { render, staticRenderFns } from "./ProjectGroupFormModal.vue?vue&type=template&id=5582889d&"
import script from "./ProjectGroupFormModal.vue?vue&type=script&lang=js&"
export * from "./ProjectGroupFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports